import { createSelector, defaultMemoize } from 'reselect';
import { userSchema } from '../normalizr/schemas/user';
import { getDataEntityById, getAllDataEntitiesForSchema } from '../entities';
import { PapiUser } from '@wix/da-papi-types';
import objValues from 'lodash/values';

export const getUserById = defaultMemoize((state, id) =>
  getDataEntityById(state, userSchema, id)
);

export const getUsersByUsernames = createSelector<
  any,
  string[] | undefined,
  any,
  string[],
  PapiUser[]
>(
  [
    state => getAllDataEntitiesForSchema(state, userSchema),
    (state, usernames = []) =>
      usernames.map(username => username.toLowerCase()),
  ],
  (usersKeyedByIds: { [id: number]: PapiUser }, usernames: string[]) =>
    objValues(usersKeyedByIds).filter(user =>
      usernames.includes(user.username.toLowerCase())
    )
);

export const createGetUsersByIds = () =>
  createSelector<
    any,
    number[],
    { [k: string]: PapiUser },
    number[],
    PapiUser[]
  >(
    [
      state => getAllDataEntitiesForSchema<PapiUser, any>(state, userSchema),
      (state, ids) => ids,
    ],
    (usersKeyedByIds, ids): PapiUser[] => ids.map(id => usersKeyedByIds[id])
  );
export const getUsersByIds = createGetUsersByIds();
